<div class="sh-form-check">
  <input
    #checkboxEl
    type="checkbox"
    [formControl]="control"
    [id]="id"
    class="sh-checkbox sh-form-check__input sh-form-group__input"
    [attr.aria-describedBy]="invalid ? describeLabelId : null"
    [attr.aria-invalid]="invalid"
    [shIndeterminate]="indeterminate$ | async"
    [attr.disabled]="disabled ? true : null"
    />

  @if (label && !hideInnerLabel) {
    <label [for]="id" class="sh-form-check__label" [class.--disabled]="disabled">{{ label }}</label>
  }
</div>
